import React from 'react';
import type { MenuItem, Order } from '../../types';
import MenuItemCard from './MenuItemCard';
import { getAvailableQuantity } from '../../lib/dailyAvailability';

interface MenuItemsGridProps {
  items: MenuItem[];
  onAddItem: (item: MenuItem) => void;
  orders?: Order[]; // Optional orders for reserved quantity calculation
}

const MenuItemsGrid: React.FC<MenuItemsGridProps> = ({ items, onAddItem, orders = [] }) => {
  return (
    <main className="flex-1 p-2 sm:p-3 md:p-4 overflow-y-auto bg-gradient-to-br from-gray-50 to-gray-100">
        {items.length === 0 ? (
          <div className="flex items-center justify-center h-full">
            <p className="text-gray-500 text-xs sm:text-sm md:text-base lg:text-lg">No items available in this category</p>
          </div>
        ) : (
          <div className="grid gap-1.5 sm:gap-2 md:gap-2.5 lg:gap-3" style={{gridTemplateColumns: 'repeat(auto-fill, minmax(85px, 1fr))'}}>
            {items.map(item => {
              const availableQuantity = item.hasDailyAvailability ? getAvailableQuantity(item, orders) : undefined;
              return (
                <MenuItemCard 
                  key={item.id} 
                  item={item} 
                  onAddItem={onAddItem}
                  availableQuantity={availableQuantity}
                />
              );
            })}
          </div>
        )}
    </main>
  );
};

export default MenuItemsGrid;
